var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpectationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M47.9869 29.674H13.0435V31.3435H47.9869V29.674Z",
    fill: "#0C233C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1653 55.8001V32.987H13.187L13.187 55.8001H29.1653Z",
    fill: "#0C233C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9087 28.0305V5.21741L31.9304 5.21741V28.0305H47.9087Z",
    fill: "#0C233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectationsIcon);
export default __webpack_public_path__ + "static/media/ExpectationsIcon.cb0409622f9eb77bb1a9067f64c24e2d.svg";
export { ForwardRef as ReactComponent };